// This will be aligned with design system when Post Assessment Roadmap goes live
export const colors = {
    success: '#27b518',
    danger: '#EF374E',
    warning: '#FBBC05',
    undefined: '#8ba7c4',
    black: '#000000',
    pearlBlack: '#21272A',
    plantinumDark: '#e1e1e1',
    lightGray: '#B8B8B8',
    dodgerBlue: '#5599D4',
};
